query GetSuggestedReplies($input: SuggestedRepliesInput!) {
    suggestedReplies(input: $input) {
        replies {
            id
            title
            body
        }
        status
    }
}
